import React from 'react';
import { useRootContext } from '@jarvis/react-portal-addons';
import GenericThemeProvider from '../../../shared/GenericThemeProvider';
import {
  Container, Grid, PrivatePickupContainer, SideCardsContainer,
} from './styles';
import PrivatePickupWidget from '../PrivatePickupWidget';
import SolutionCards from '../SolutionCards';
import useDeviceCacheApiCall from '../../../hooks/useDeviceCacheApiCall';
import Banner from '../Banner';
import { AdminsWidget } from '../AdminsWidget';
import { WorkspaceWidget } from '../WorkspaceWidget';

const EndUserConsolidatedDashboard = () => {
  const { shell, stack } = useRootContext();

  const { authProvider } = shell;

  const deviceCache = useDeviceCacheApiCall({
    authProvider,
    stack,
    init: true,
  });

  return (
    <GenericThemeProvider>
      <Container data-testid="end-user-dashboard">
        <Banner
          data-testid="banner-container" deviceCache={deviceCache}
          showNotifications={false}
        />

        <Grid>
          <SolutionCards
            deviceCache={deviceCache}
          />

          <PrivatePickupContainer data-testid="private-pickup-container">
            <PrivatePickupWidget data-testid="private-pickup-widget" deviceCache={deviceCache} />
          </PrivatePickupContainer>

          <SideCardsContainer data-testid="side-cards-container">
            <AdminsWidget />
            <WorkspaceWidget />
          </SideCardsContainer>

        </Grid>
      </Container>
    </GenericThemeProvider>
  );
};

export default EndUserConsolidatedDashboard;
